import React, { Component } from 'react'
import { Link } from 'react-router-dom';

class Thanks extends Component {
    render() {
        return (
            <div className="container">
                <h2 className="white-text row center">Thank you for contacting us</h2>
                <h6 className="white-text row center">Our team will reach you to you soon. You may also contact us at the number below.</h6>
                <div className="row">
                    <Link to='/' className="btn btn-large green col s4 push-s4" > Back to Home </Link>
                </div>
            </div>
        )
    }
}

export default Thanks;